<template>
    <div class="thanks-total">
        <div class="thanks-total__row">
            <p class="thanks-total__name">
                {{ messages.price }}
            </p>
            <p class="thanks-total__price">
                {{ getPrice.printPriceOld }}
            </p>
        </div>
        <div class="thanks-total__row" v-if="getPrice.discount > 0">
            <p class="thanks-total__name">
                {{ messages.discountPrice }}
            </p>
            <DefSale>
                {{ getPrice.printDiscount }}
            </DefSale>
        </div>
        <div class="thanks-total__row" v-if="getDelivery.price.printPrice">
            <p class="thanks-total__name">
                {{ messages.delivery }}
            </p>
            <p class="thanks-total__price">
                {{ getDelivery.price.printPrice }}
            </p>
        </div>
        <div v-if="getPrice.printPrice" class="thanks-total__row">
            <p class="thanks-total__name">
                {{ messages.totalPrice }}
            </p>
            <p class="thanks-total__total">
                {{ getPrice.printPrice }}
            </p>
        </div>
    </div>
</template>

<script>
import DefSale from "../../def/DefSale/DefSale";
export default {
    name: 'ThanksTotal',
    props: ['result', 'messages'],
    components: {
        DefSale,
    },
    computed: {
        getPrice() {
            return this.result?.order?.price;
        },
        getDelivery() {
            return this.result?.order?.delivery;
        }
    }
}
</script>

<style lang="scss" scoped>
.thanks-total{
    display: grid;
    grid-row-gap: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    color: #757575;
    @include point-md{
        font-size: 16px;
    }
    p{
        line-height: 100%;
    }
    &__row{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &__price{
        color: var(--text-colour-primary);
    }
    &__total{
        color: var(--text-colour-primary);
    }
    //:deep(.def-sale){
    //    font-size: rem(14);
    //}
}
</style>